module.exports = __webpack_public_path__ + "img/mayorpuzser3.9d37af93.svg";